import { useEffect, useRef, useState } from "react";
import { useAuth } from "@itaas/core/auth/useAuth";
import { loadStoredSession } from "@itaas/core/auth/auth.storage";
import {
  buildSuiteLoginUrl,
} from "@itaas/core/auth/suite-redirect";
import { applyHandoffFromHash } from "@itaas/core/modules/handoff";

export function AuthHandoffPage() {
  const { verifySession } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) return;

    const run = async () => {
      const target = applyHandoffFromHash(window.location.hash);
      if (target) {
        handledRef.current = true;
        window.history.replaceState(null, "", window.location.pathname);
        try {
          await verifySession();
        } catch {
          // Session déjà persistée via handoff.
        }
        window.location.replace(target);
        return;
      }

      if (loadStoredSession()?.tokens?.accessToken) {
        handledRef.current = true;
        window.location.replace("/modules");
        return;
      }

      setError("Lien de session invalide ou expiré.");
    };

    void run();
  }, [verifySession]);

  if (error) {
    return (
      <div className="suite-center-message">
        <p className="text-danger mb-3">{error}</p>
        <a href={buildSuiteLoginUrl({ suiteUrl: window.location.origin })} className="btn btn-primary btn-sm">
          Se connecter
        </a>
      </div>
    );
  }

  return (
    <div className="suite-center-message">
      <p className="text-muted mb-0">Connexion à ITaaS Suite…</p>
    </div>
  );
}
